/**
 * Comma-separated list for HTML file input `accept` on document pickers.
 * Includes MIME types and extensions so OS file dialogs filter reliably.
 */

const ALLOWED_DOCUMENT_UPLOAD_ACCEPT = [
  ".pdf", "application/pdf",
  ".doc", "application/msword",
  ".docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ".xls", "application/vnd.ms-excel",
  ".xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ".csv", "text/csv",
  ".txt", "text/plain",
  ".odt", "application/vnd.oasis.opendocument.text",
  ".ods", "application/vnd.oasis.opendocument.spreadsheet",
  ".png", "image/png",
  ".jpg", ".jpeg", "image/jpeg",
  ".webp", "image/webp",
  ".svg", "image/svg+xml"
].join(",");

export { ALLOWED_DOCUMENT_UPLOAD_ACCEPT };
